import React, { useEffect, useState } from "react";
import Helmet from "react-helmet";
import axios from "../../plugins/axios";
import { connect } from "react-redux";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import Loader from "../Loader";
import { spacing } from "@material-ui/system";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../redux/reducers/knowledgeReducer";
import LinkedDocumentsCard from "./LinkedDocumentsCard";
import LinkedArticlesCard from "./LinkedArticlesCard";
import KnowledgeArticleDetailsCard from "./KnowledgeArticleDetailsCard";
import { grey } from "@material-ui/core/colors";
import MyCKEditor from '../../ckeditor/MyCKEditor';

import {
    Typography,
    Card as MuiCard,
    CardContent,
    Grid,
    Button as MuiIconButton,
    CircularProgress,
    Box,
    TextField
} from "@material-ui/core";
import {
    Edit as EditIcon,
    Replay as UndoIcon,
    Save as SaveIcon
} from "@material-ui/icons";

const IconButton = styled(MuiIconButton)`
    padding: 2px;
    margin-top: -2px;
    margin-left: 2px;
    min-width: 0;
    color: ${grey[700]};
`;

const Card = styled(MuiCard)(spacing);

const apiUrl = process.env.REACT_APP_CASENEST_API_URL;

const KnowledgeArticle = ({ getInitialData, knowledgeState, updateArticle }) => {
    const { categories } = knowledgeState;
    const { articleId } = useParams();

    const [article, setArticle] = useState();

    const [summary, setSummary] = useState("");  
        
    const handleArticleSave = async () => {
        let body = editor.getData();  

        setArticleMode("saving");
        let newArticle = { ...article, body };
        await axios.post(`${apiUrl}/knowledge/updatearticle`, { id: article.id, body });
        setArticle(newArticle);
        setArticleMode("view");
    };

    const handleSummarySave = async () => {
        setSummaryMode("saving");
        let newArticle = { ...article, summary };
        await axios.post(`${apiUrl}/knowledge/updatearticle`, { id: article.id, summary });
        setArticle(newArticle);
        setSummaryMode("view");
    }

    const handleSummaryReset = () => {
        setSummary(article.summary);
        setSummaryMode("view");
    }

    const [articleMode, setArticleMode] = useState("view");
    const [summaryMode, setSummaryMode] = useState("view");

    const [editor, setEditor] = useState();

    useEffect(() => {

        const getData = async () => {
            let response = await axios.get(`${apiUrl}/knowledge/article/${articleId}`);
            let article = response.data;

            if (article.reviewDate)
                article.reviewDate = new Date(article.reviewDate);

            if(article.nextReviewDate)
                article.nextReviewDate = new Date(article.nextReviewDate);

            setArticle(article);
        };

        if (categories.length === 0)
            getInitialData();
        else
            getData();

    }, [categories, articleId]);    

    useEffect(() => {

        if (article)
            setSummary(article.summary);

    }, [article]);

    if (!article)
        return <Loader />;    

    return (
        <React.Fragment>
            <Helmet title="Knowledge Base" />
            <Card mb={6}>
                <CardContent>
                    <Typography variant="h3" gutterBottom>{article.name}</Typography>
                </CardContent>

            </Card>
            <Grid justifyContent="space-between" container spacing={6}>
                <Grid item xs={5}>
                    <KnowledgeArticleDetailsCard article={article} setArticle={setArticle} />
                    <LinkedArticlesCard article={article} setArticle={setArticle} />
                    <LinkedDocumentsCard article={article} setArticle={setArticle} />                    
                </Grid>
                <Grid item xs={7}>
                    <Card mb={6}>
                        <CardContent>
                            <Box display="flex">
                                <Box flexGrow={1} alignItems="center">
                                    <Typography variant="h6" gutterBottom>Summary</Typography>
                                </Box>
                                <Box>
                                    {
                                        summaryMode === "view" && (
                                        <IconButton onClick={() => setSummaryMode("edit")}>
                                            <EditIcon />
                                        </IconButton>
                                    )}
                                    {
                                        summaryMode === "edit" && (
                                        <React.Fragment>
                                            <IconButton onClick={handleSummaryReset}><UndoIcon /></IconButton>
                                            <IconButton onClick={handleSummarySave}><SaveIcon /></IconButton>
                                        </React.Fragment>
                                    )}
                                    {
                                        summaryMode === "saving" && (
                                        <CircularProgress
                                            size={21}
                                            style={{ marginLeft: "9px" }}
                                        />
                                    )}
                                </Box>
                            </Box>
                            {
                                summaryMode === "edit"
                                    ? <TextField
                                        style={{ width: '100%' }}
                                        multiline
                                        rows={8}
                                        variant="outlined"
                                        value={summary}
                                        onChange={e => setSummary(e.target.value)}
                                    />
                                    : <div> {article.summary}</div>
                            }
                        </CardContent>
                    </Card>
                    <Card mb={7}>
                        <CardContent>
                            <Box display="flex">
                                <Box flexGrow={1} alignItems="center">
                                    <Typography variant="h6" gutterBottom>Article</Typography>
                                </Box>
                                <Box>
                                    {
                                        articleMode === "view" && (
                                        <IconButton onClick={() => setArticleMode("edit")}>
                                            <EditIcon />
                                        </IconButton>
                                    )}
                                    {
                                        articleMode === "edit" && (
                                        <React.Fragment>
                                            <IconButton onClick={() => setArticleMode("view")}><UndoIcon /></IconButton>
                                            <IconButton onClick={handleArticleSave}><SaveIcon /></IconButton>
                                        </React.Fragment>
                                    )}
                                    {
                                        articleMode === "saving" && (
                                        <CircularProgress
                                            size={21}
                                            style={{ marginLeft: "9px" }}
                                        />
                                    )}
                                </Box>
                            </Box>
                            {
                                articleMode === "edit"
                                    ? <MyCKEditor
                                        initialData={article.body}
                                        setEditor={setEditor}
                                        onChange={() => { }}
                                        onFocus={() => { }}
                                        type="article"
                                    />
                                    : <div dangerouslySetInnerHTML={{ __html: article.body }} />
                            }
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </React.Fragment>
    );
};

const mapStateToProps = (state) => ({
    knowledgeState: state.knowledgeReducer
});

const mapDispatchToProps = (dispatch) => bindActionCreators(actionCreators, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(KnowledgeArticle);
